// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Video__container-c3bbfa {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
  cursor: pointer;
  max-width: var(--max-width-article-layout);
  max-height: 400px;
  border-radius: 16px;
  background-color: var(--base-17);
}

.Video__image-e098da {
  background-color: var(--base-20);
  max-height: 100%;
  max-width: 100%;
}

.Video__uploader-be1373 {
  color: var(--addition-50);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background-color: var(--addition-40_60);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Video__icon-dd6d2e {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Payloads/Video/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  background-size: cover;\n  cursor: pointer;\n  max-width: var(--max-width-article-layout);\n  max-height: 400px;\n  border-radius: 16px;\n  background-color: var(--base-17);\n}\n\n.image {\n  background-color: var(--base-20);\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.uploader {\n  color: var(--addition-50);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  background-color: var(--addition-40_60);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Video__container-c3bbfa`,
	"image": `Video__image-e098da`,
	"uploader": `Video__uploader-be1373`,
	"icon": `Video__icon-dd6d2e`
};
module.exports = ___CSS_LOADER_EXPORT___;
